import React from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { getApiBaseUrl } from "@/lib/config";

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  const apiBaseUrl = getApiBaseUrl();

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "local",
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    sendDefaultPii: false,
    // Upload failures can coincide with lost connectivity. Persist failed
    // events locally and send them after reconnecting or reopening the PWA.
    transport: (options) => Sentry.makeBrowserOfflineTransport()({
      ...options,
      maxQueueSize: 30,
      flushAtStartup: true,
    }),
    integrations: [
      Sentry.reactRouterBrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracePropagationTargets: [
      /^\//,
      new RegExp(`^${apiBaseUrl.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}`),
    ],
    tracesSampleRate: Number(
      import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.1,
    ),
  });
}

export { Sentry };
